<template>
  <div class="main container">
    <div class="logo col-md-12 text-center">
      <img src="./../../assets/logo-10.png">
    </div>
    <div class="col-md-12 text-center">
      <h4 class="highlight-color">{{ $t('message.verifyemail') }}</h4>
      <p class="highlight-color">{{ $t('message.intro1') }}</p>
    </div>
    <div class="col-md-6 form">
      <p
        v-if="!ready"
        class="m-0 text-center">
        {{ $t('message.pleasewait') }} <i class="fas fa-spinner spin"/>
      </p>
      <template v-if="ready">
        <p
          v-if="verify_success"
          class="m-0 text-center text-success">
          {{ $t('message.youremailhasbeenverified') }} <i class="far fa-check-circle"/>
        </p>
        <p
          v-else
          class="m-0 text-center text-danger">
          {{ $t('message.notfounddata') }}
        </p>
      </template>
    </div>
    <div class="col-md-12 text-center">
      <p
        v-if="ready"
        class="text-white mb-1">
        <router-link
          :to="{
            name: 'SignIn'
          }"
          class="text-white">
          {{ $t('message.login') }}
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const jwt = require('jsonwebtoken')

export default {
  name: 'SignIn',
  data () {
    return {
      ready: false,
      verify_success: false,
    }
  },
  computed: {
    ...mapGetters({

    }),
  },
  created: async function () {
    let key_code = this.$route.query.code

    if (key_code == undefined) {
      return this.$router.push({ name: 'signin' })
    }

    let res = await this.$store.dispatch('verifyEmail', {
      key_code: key_code,
    })

    if (res.success) {
      this.verify_success = true
    }

    this.ready = true
  },
  mounted: function () {
    // set section
    this.$store.dispatch('setSection', 'login')
    // set title
    this.setTabTitle(this.$t('message.verifyemail'))
  },
  methods: {

  },
}
</script>
<style scoped>
.main {

}
.logo {
  margin: 25px 0 25px 0;
}
.form {
  padding: 25px 25px 20px 25px;
  max-width: 400px;
  margin: 25px auto;
  background: #FFF;
  border-radius: 2px;
}
.text {
  color: #282D35;
}
a {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/account/CheckVerifyEmail.vue